import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdDownloadForOffline } from "react-icons/md";
import styles from "./CalibrationArray.module.scss";

const CalibrationArray = ({ cabname, onPressBack, cab, hasCalibData = true }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState({ id: null, type: null });

  const getStatusClass = (number) => {
    if (number === null || number === undefined) return styles.statusNoData;
    if (number <= 0) return styles.statusLate;
    if (number <= 30) return styles.statusWarning;
    return styles.statusOk;
  };

  const getBubbleText = (number) => {
    if (number === null || number === undefined) return t("calibration.no_calibration");
    const n = Math.abs(number);
    if (number >= 0) return t("calibration.days_remaining", { n });
    return t("calibration.days_overdue", { n });
  };

  const LedItem = ({ type, value, label }) => {
    const bubbleOpen = selected.id === cab?.id && selected.type === type;

    return (
      <div
        className={styles.ledItem}
        role="presentation"
        onMouseEnter={() => setSelected({ id: cab?.id, type })}
        onMouseLeave={() => setSelected({ id: null, type: null })}
      >
        <div className={`${styles.statusChip} ${getStatusClass(value)}`}>{label}</div>

        {bubbleOpen && (
          <div className={styles.bubble}>
            <div className={styles.bubbleTitle}>{label}</div>
            <div className={styles.bubbleText}>{getBubbleText(value)}</div>
            <div className={styles.bubbleHint}>{t("calibration.click_to_download")}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div className={styles.cabMeta}>
          <h3 className={styles.cabname} title={cabname}>
            {cabname || "—"}
          </h3>
          <div className={styles.subInfo}>ID: {cab?.id ?? "—"}</div>
        </div>

        {hasCalibData && (
          <div className={styles.ledRow}>
            <LedItem type="co" value={cab?.numberDayBone} label="CO" />
            <LedItem type="head" value={cab?.numberDayHead} label="Casque" />
            <LedItem type="insert" value={cab?.numberDayInsert} label="Inserts" />
            <LedItem type="speakers" value={cab?.numberDaySpeakers} label="CL" />
          </div>
        )}

        {hasCalibData && (
          <button
            className={`${styles.downloadBtn} has-tooltip tooltip-left`}
            type="button"
            onClick={onPressBack}
            aria-label={t("calibration.download_certificate")}
          >
            <MdDownloadForOffline />
          </button>
        )}

        {!hasCalibData && (
          <div className={styles.noDataMessage}>Aucune donnee de calibration</div>
        )}
      </div>
    </div>
  );
};

export default CalibrationArray;
